function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import formList from '@/views/develop/module/components/formList';
import conditionDialog from '@/components/develop/conditionDialog';
import selectLabel from '@/components/form-common/select-label';
export default {
  name: '',
  components: {
    formList: formList,
    conditionDialog: conditionDialog,
    selectLabel: selectLabel
  },
  props: {
    type: {
      type: String,
      default: ''
    },
    isBack: {
      // 返回图标
      type: Boolean,
      default: false
    },
    treeData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    treeDefault: {
      type: [String, Number],
      default: ''
    },
    dropdownList: {
      type: Array,
      // 操作列表
      default: function _default() {
        return [];
      }
    },
    total: {
      type: Number,
      default: 0
    },
    search: {
      type: Array,
      // 展开的筛选条件
      default: function _default() {
        return [];
      }
    },
    ids: {
      type: Array,
      // 父组件表格多选id集合
      default: function _default() {
        return [];
      }
    },
    viewSearch: {
      type: Array,
      // 高级筛选
      default: function _default() {
        return [];
      }
    },
    timeVal: {
      type: Array,
      // 默认时间区间
      default: function _default() {
        return [];
      }
    },
    isViewSearch: {
      type: Boolean,
      default: true
    },
    // 排序搜索
    sortSearch: {
      type: Boolean,
      default: true
    },
    isAddBtn: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    btnText: {
      type: String,
      default: '新增'
    },
    btnIcon: {
      type: Boolean,
      default: true
    },
    btnType: {
      type: String,
      default: ''
    },
    alert: {
      type: String,
      default: ''
    },
    isTotal: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      where: {
        sort_field: 'created_at',
        sort_value: ''
      },
      loading: false,
      seniorSearch: this.search,
      additional_search: [],
      filterData: [],
      sortList: [{
        name: '升序',
        value: 'asc'
      }, {
        name: '降序',
        value: 'desc'
      }, {
        name: '默认排序',
        value: ''
      }],
      timeSearch: [{
        name: '创建时间',
        value: 'created_at'
      }, {
        name: '修改时间',
        value: 'updated_at'
      }],
      activeIndex: 'created_at',
      sortIndex: '',
      treeValue: ''
    };
  },
  watch: {
    search: function search(val) {
      this.seniorSearch = val;
    },
    treeDefault: {
      handler: function handler(val) {
        this.treeValue = val;
      },
      immediate: true
    }
  },
  computed: {
    showHeader: function showHeader() {
      return this.title !== '' || this.isAddBtn || this.dropdownList.length > 0;
    }
  },
  methods: {
    handleEmit: function handleEmit(data) {
      this.where = _objectSpread({}, data);
      this.$emit('confirmData', this.where);
    },
    onShow: function onShow() {
      this.$store.state.business.conditionDialog = true;
    },
    backFn: function backFn() {
      if (this.isBack) {
        this.$emit('backFn');
      }
    },
    resetSearch: function resetSearch() {
      this.treeValue = '';
      this.where = {};
      this.additional_search = [];
      var data = {
        list: [],
        type: '',
        additional_search_boolean: '0'
      };
      this.$store.commit('uadatefieldOptions', data);
      this.$emit('confirmData', 'reset');
    },
    addDataFn: function addDataFn() {
      this.$emit('addDataFn');
    },
    dropdownSearch: function dropdownSearch(item) {
      this.$emit('dropdownFn', item);
    },
    handleLabelConf: function handleLabelConf(val, item) {
      this.$emit('dropdownFn', item, val);
    },
    handleClick: function handleClick(item, index) {
      this.where.sort_field = item.value;
      this.activeIndex = item.value;
      this.$emit('confirmData', this.where);
    },
    sortFn: function sortFn(item, index) {
      this.where.sort_value = item.value;
      this.sortIndex = item.value;
      this.$emit('confirmData', this.where);
    },
    // 高级筛选样式
    saveCondition: function saveCondition(data) {
      this.additional_search = this.$store.state.business.fieldOptions.list;
      var obj = {};
      if (this.additional_search == 0) {
        this.$store.state.business.fieldOptions.resetList.map(function (item) {
          if (item.type === 'date_picker') {
            obj[item.field] = '';
          } else {
            obj[item.field] = '';
          }
        });
      } else {
        this.additional_search.map(function (item) {
          if (item.type === 'date_picker') {
            obj[item.field] = item.min + '-' + item.max;
          } else {
            obj[item.field] = item.option;
          }
        });
      }
      this.$emit('confirmData', _objectSpread(_objectSpread({}, this.where), obj));
    },
    treeChange: function treeChange(value) {
      this.$emit('treeChange', {
        value: value
      });
    }
  }
};